// This icon file is generated automatically.
var PFolderOpenOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.5 5.94h-1.69V4.16a.5.5 0 00-.5-.5H6.4L4.56 1.91a.13.13 0 00-.09-.03H.5a.5.5 0 00-.5.5v9.25c0 .27.22.5.5.5h10.9a.5.5 0 00.47-.32l2.1-5.19a.5.5 0 00-.46-.69zM1.12 3h2.95l1.87 1.79h4.75v1.15H2.72a.5.5 0 00-.47.31l-1.13 2.8V3zm9.93 8H1.48L3.1 7h9.57l-1.62 4z", "fill-rule": "nonzero" } }] }, "name": "p-folder-open", "theme": "outlined" };
export default PFolderOpenOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFolderOpenOutlined.js
// module id = 3425
// module chunks = 0